import React from "react";

import { Box, Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { times } from "lodash";

const TableCardSkeleton = () => (
  <Box paddingTop={1} paddingRight={2} paddingBottom={1} paddingLeft={2}>
    {times(3, idx => (
      <Grid key={idx} container spacing={2}>
        <Grid item xs={6}>
          <Skeleton width="100%" height="40px" />
        </Grid>
        <Grid item xs={6}>
          <Skeleton width="100%" height="40px" />
        </Grid>
      </Grid>
    ))}
  </Box>
);

export default TableCardSkeleton;
